const moduleRoutes = [
    {
        path: '/package-group',
        name: 'packageGroups',
        children: [
            {
                path: '',
                name: 'packageGroupList',
                component: () => import('@/modules/package_group/list/List.vue'),
                meta: {
                    resource: 'package-groups',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Package Groups',
                    breadcrumbs: [{ title: 'Package Group List', routeName: 'packageGroupList' }]
                }
            },
            {
                path: 'new',
                name: 'packageGroupNew',
                component: () => import('@/modules/package_group/entry/New.vue'),
                meta: {
                    resource: 'package-groups',
                    action: 'create',
                    layout: 'default',
                    auth: true,
                    title: 'New Package Group',
                    breadcrumbs: [
                        { title: 'Package Group List', routeName: 'packageGroupList' },
                        { title: 'New', routeName: 'packageGroupNew' }
                    ]
                }
            },
            {
                path: ':id/edit',
                name: 'packageGroupEdit',
                component: () => import('@/modules/package_group/entry/Edit.vue'),
                meta: {
                    resource: 'package-groups',
                    action: 'edit',
                    layout: 'default',
                    auth: true,
                    title: 'Edit Package Group',
                    breadcrumbs: [
                        { title: 'Package Group List', routeName: 'packageGroupList' },
                        { title: 'Edit', routeName: 'packageGroupEdit' }
                    ]
                }
            }
        ]
    }
]

export default moduleRoutes
